module.exports = __webpack_public_path__ + "static/MPMotM-coverart-f3176769f1a827e37b1f956aeabf360f.jpg";